import type { Params, SvgoLevel, StrokeFill } from '../../lib/types';
import { Select, Slider, Toggle } from './widgets';

export function PostprocessGroup({ params, setParam }: { params: Params; setParam: <K extends keyof Params>(k: K, v: Params[K]) => void }) {
  return (
    <>
      <Select<SvgoLevel> label="SVGO optimisation" value={params.svgo} options={[['off', 'off'], ['safe', 'safe'], ['aggressive', 'aggressive']]} onChange={(v) => setParam('svgo', v)} />
      <Slider label="Path simplification" min={0} max={5} step={0.1} value={params.pathSimplify} onChange={(v) => setParam('pathSimplify', v)} />
      <Select<StrokeFill> label="Stroke vs fill" value={params.strokeFill} options={[['fill', 'fill'], ['stroke', 'stroke'], ['both', 'both']]} onChange={(v) => setParam('strokeFill', v)} />
      <Slider label="Stroke width" min={0.1} max={10} step={0.1} value={params.strokeWidth} onChange={(v) => setParam('strokeWidth', v)} />
      <Toggle label="Merge paths" value={params.mergePaths} onChange={(v) => setParam('mergePaths', v)} />
      <Toggle label="Round to integer coords" value={params.roundCoords} onChange={(v) => setParam('roundCoords', v)} />
    </>
  );
}
